'use strict';

import Component from 'generic.basecomponent';
import $ from 'jquery';
import JGApi from '../../../general/js/jg-api';
import template from '../html/jg-imagery.hbs';
import templateEmpty from '../html/jg-imagery-empty.hbs';
import ImageGallery from '../../image-gallery/js/generic.image-gallery';

export default class JgImagery extends Component {
    constructor(el) {
        super(el);
        this.$container = $(this.container);
        this.init();
    }

    init() {
        let pageName = this.$container.data('page-name');
        if (!pageName) {
            this.$container.addClass('js-init-errors');
            return false;
        }

        this.$container.addClass('is-loading');
        JGApi.getInstance().getPageDetails(pageName).then((response) => {
            this.renderImagery(response.media.images);
        }, (error) => {
            this.renderError(error);
        }).then(() => {
            this.$container.removeClass('is-loading');
        });
    }

    renderImagery(images) {
        if (images.length > 0) {
            let content = template({images});
            this.$container.html(content);
            let $gallery = this.$container.find('.js-image-gallery');
            let gallery = new ImageGallery($gallery[0]);
        } else {
            this.renderEmpty();
        }
    }

    renderEmpty() {
        this.$container.html(templateEmpty({}));
    }


    renderError(error) {
        console.log(error);
        this.$container.html(JGApi.getDefaultErrorMessage());
    }
}



// WEBPACK FOOTER //
// ./app/components/jg-imagery/js/generic.jg-imagery.js